import React from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"
import { wrapper, body } from "./Faq.module.css"

const Faq = ({ questions }) => {
  return (
    <div className={`${wrapper} faq`}>
      {questions.map((faq, i) => (
        <details key={i}>
          <summary>{faq.question}</summary>
          <div className={body}>{parse(faq.answer)}</div>
        </details>
      ))}
    </div>
  )
}

Faq.propTypes = {
  questions: PropTypes.array,
}

export { Faq }
